import { render, staticRenderFns } from "./LbaIconPicker.vue?vue&type=template&id=4a95481f"
import script from "./LbaIconPicker.vue?vue&type=script&lang=js"
export * from "./LbaIconPicker.vue?vue&type=script&lang=js"
import style0 from "./LbaIconPicker.vue?vue&type=style&index=0&id=4a95481f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports